import React, { Component } from 'react';
import { withStyles, Grid, Typography } from '@material-ui/core';
import styles from './styles/ProblemsStatsStyles';
import { ResponsiveContainer, BarChart, XAxis, YAxis, Tooltip, CartesianGrid, Bar, Cell, Rectangle, LabelList } from 'recharts';

const colors = [
  '#d62728', '#1f77b4', '#ff7f0e', '#2ca02c', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf',
  '#E91E63', '#9C27B0', '#FF1744', '#3F51B5', '#7986CB', '#2196F3', '#009688', '#64FFDA', '#CDDC39', '#455A64'
];

const CustomTooltip = ({active, payload, label}) => {
    if (active) {
      return (
        <div className="custom-tooltip" style={{backgroundColor: 'rgba(0, 0, 0, 0.5)', color: '#fff', padding: 2}}>
          <p className="label">{`${label}: ${payload[0].value}%`}</p>
          <p className="desc">{`Quantidade de Veículos: ${payload[0].payload.count}`}</p>
        </div>
      );
    }
    return null;
};

class ProblemsStats extends Component {
  render() {
    const { classes, problemsStats } = this.props;
    this.filterProblems(problemsStats);
    if (problemsStats && problemsStats.length > 0) {
      return (
        <div>
          <Typography variant='title' className={classes.tableTitle} id='tableTitle'>
            Porcentagem de Veículos com Problemas no Período
          </Typography>
          <Grid className={classes.root}>
            <ResponsiveContainer width='100%' height='100%'>
              <BarChart data={problemsStats} margin={{top: 35, bottom: 35, right: 30}}>
                <XAxis dataKey='name' hide={true}/>
                <YAxis/>
                <CartesianGrid strokeDasharray='3 3'/>
                <Tooltip content={<CustomTooltip/>}/>
                <Bar
                  dataKey='rate'
                  shape={<Rectangle/>}
                >
                  {problemsStats.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % 20]}/>
                  ))}
                  <LabelList dataKey='name' position='top' />
                </Bar>
              </BarChart>    	  
            </ResponsiveContainer>
          </Grid>
        </div>
      );
    }

    return null;
  }

  filterProblems = (problemsStats) => {
    const index = problemsStats.findIndex(item => item.id === 'WEIRD_SPEED');
    if (index > -1) problemsStats.splice(index, 1);
  }
}

export default withStyles(styles)(ProblemsStats);


// WEBPACK FOOTER //
// ./src/main/components/ProblemsStats.jsx